import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Skeleton,
  Modal,
  Form,
  Transfer,
  Row,
  Col,
  Select,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { InfoOutlined } from "@ant-design/icons";
import "./newtest.css"


import {
  changeModeQuestionSelect,
  fetchQuestionsBasedOnSubject,
  addQuestionToQuestionQueue,
} from "../../../reducers/test";
import {
  fetchAllQuestions,
  fetchLevelSubjectWiseQuestion,
} from "../../../features/trainerAsync";
import "./newtest.css";
import Alert from "../../common/alert";
import {
  givenComponents,
  givenDifficulties,
  givenExams,
  givenLevels,
  givenSchools,
  givenYears,
} from "../../common/constants";
import apis from "../../../services/Apis";
import { Post } from "../../../services/axiosCall";

const GeneraterandomQuestion = ({ mode }) => {
  const [state, setState] = useState({
    generating: false,
    autogenerate: true,
    ActiveQuestionId: null,
    Mvisible: false,
    level: null,
    difficulty: null,
    school: null,
    year: null,
    component: null,
    exam: null,
  });

  const [filteredQuestions, setFilteredQuestions] = useState([]);
  const isFirstRender = useRef(true);

  const dispatch = useDispatch();
  const { newtestFormData, questionsAvailablebasedonSubject } = useSelector(
    (state) => state.test
  );
  console.log(newtestFormData);

  useEffect(() => {
    dispatch(changeModeQuestionSelect(mode));
    if (newtestFormData.testSubject) {
      dispatch(fetchAllQuestions(newtestFormData.testSubject));
    }
  }, [dispatch, newtestFormData.testSubject, mode]);

  // const handleChange = (targetKeys) => {
  //   // console.log(targetKeys);
  //   dispatch(addQuestionToQuestionQueue(targetKeys));
  // };

  // Apply filters whenever filter criteria or questions change
  useEffect(() => {
    if (
      questionsAvailablebasedonSubject &&
      questionsAvailablebasedonSubject.length > 0
    ) {
      applyFilters();
    }
  }, [state, questionsAvailablebasedonSubject]);

  const applyFilters = () => {
    const filtered = questionsAvailablebasedonSubject.filter((question) => {
      return (
        (!state.level || question.level === state.level) &&
        (!state.difficulty || question.difficulty === state.difficulty) &&
        (!state.school || question.school === state.school) &&
        (!state.year || question.year === state.year) &&
        (!state.component || question.component === state.component) &&
        (!state.exam || question.exam === state.exam)
      );
    });
    setFilteredQuestions(filtered);
  };

  const handleLevelDifficultyChange = (name, value) => {
    setState((prev) => ({
      ...prev,
      [name]: value === "" ? null : value,
    }));
  };
  //  useEffect(() => {
  //   if (isFirstRender.current) {
  //     isFirstRender.current = false;
  //     return;
  //   }

  //   if (!newtestFormData.testSubject) return;

  //   dispatch(
  //     fetchLevelSubjectWiseQuestion({
  //       subjectId: newtestFormData.testSubject,
  //       ...state,
  //     })
  //   );
  // }, [...Object.values(state)]);

  const renderItem = (item) => {
    const customLabel = (
      <span
        style={{
          color: "black",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <Button
          shape="circle"
          onClick={() =>
            setState((prev) => ({
              ...prev,
              ActiveQuestionId: item._id,
              Mvisible: true,
            }))
          }
          icon={
            <InfoOutlined
              style={{
                color: "white",
                transition: "color 0.3s",
              }}
            />
          }
          style={{
            background:
              "linear-gradient(to right,rgb(80,190,189),rgb(0,153,153),rgb(0,153,203))",
            color: "greenblue",
          }}
          size="small"
        ></Button>
        {item.body}
      </span>
    );
    return {
      label: customLabel,
      value: item._id,
      // Add all searchable fields to the option object
      difficulty: item.difficulty,
      level: item.level,
      school: item.school,
      year: item.year,
      component: item.component,
      exam: item.exam,
      body: item.body,
      topic: item.topic,
    };
  };

  const handleCancel = () => {
    setState((prev) => ({ ...prev, Mvisible: false }));
  };

  return (
    <div>
      <Row style={{ display: "flex", flexDirection: "row", gap: "15px" }}>
        {[
          { label: "Level", options: givenLevels, name: "level" },
          {
            label: "Difficulty",
            options: givenDifficulties,
            name: "difficulty",
          },
          { label: "School", options: givenSchools, name: "school" },
          { label: "Year", options: givenYears, name: "year" },
          { label: "Component", options: givenComponents, name: "component" },
          { label: "Exam", options: givenExams, name: "exam" },
        ].map(({ label, options, name }) => (
          <Form.Item label={label} hasFeedback key={name} layout="vertical">
            <Select
              showSearch
              style={{ width: 150 }}
              placeholder={`Select ${label}`}
              optionFilterProp="children"
              allowClear
              onChange={(value) => handleLevelDifficultyChange(name, value)}
              value={state[name] || undefined} // Convert null to undefined for Select component
            >
              {options.map((d) => (
                <Select.Option key={d.value} value={d.value}>
                  {d.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        ))}
      </Row>

      <Row>
        <Col offset={2} span={22}>
          <Transfer
          operations={['Add Questions','Remove Questions']}
            filterOption={(input, option) =>
              [
                "difficulty",
                "level",
                "school",
                "year",
                "component",
                "exam",
                "body",
                "topic",
              ].some((key) =>
                option[key]?.toLowerCase().includes(input.toLowerCase())
              )
            }
            showSearch
            disabled={mode === "random"}
            rowKey={(record) => record._id}
            dataSource={filteredQuestions}
            listStyle={{ width: "45%", height: 500, overflowY: "auto" }}
            targetKeys={newtestFormData.testQuestions}
            render={renderItem}
            onChange={(targetKeys) => {
              dispatch(addQuestionToQuestionQueue(targetKeys));
            }}
          />
        </Col>
      </Row>

      <Modal
        width="70%"
        style={{ top: 30,overflowX:"hidden" }}
        title="Question details"
        open={state.Mvisible}
        onCancel={handleCancel}
        footer={null}
        destroyOnHidden={true}
      >
        <SingleQuestionDetails qid={state.ActiveQuestionId} />
      </Modal>
    </div>
  );
};

export default GeneraterandomQuestion;

const SingleQuestionDetails = ({ qid }) => {
  const [fetching, setFetching] = useState(false);
  const [qdetails, setQDetails] = useState(null);

  const optn = ["A", "B", "C", "D", "E"];

  useEffect(() => {
    setFetching(true);
    Post({
      url: apis.FETCH_SINGLE_QUESTION_BY_TRAINEE,
      data: { qid },
    })
      .then((response) => {
        if (response.data.success) {
          setQDetails(response.data.data[0]);
        } else {
          Alert("error", "Error !", response.data.message);
        }
        setFetching(false);
      })
      .catch((error) => {
        setFetching(false);
        console.log(error);
        const message = error.response
          ? error.response.data.message
          : error.message;
        return Alert("error", "Error!", message);
      });
  }, [qid]);
  // console.log(qdetails?.quesimg);

  if (qdetails !== null) {
    return (
      <div>
        <div className="mainQuestionDetailsContaine">
          <div className="questionDetailsBody">
            <div dangerouslySetInnerHTML={{ __html: qdetails.body }} />
            {/* {qdetails.body} */}
          </div>
          {qdetails.quesimg ? (
            <div className="questionDetailsImageContainer">
              <img
                crossorigin="anonymous"
                alt="Question121"
                className="questionDetailsImage"
                src={qdetails?.quesimg}
                style={{ fontWeight: "900", fontSize: "1.4rem" }}
              />
            </div>
          ) : null}
          <div>
            {qdetails.options
              ? qdetails.options.map((d, i) => {
                  return (
                    <div key={i}>
                      <Row
                        type="flex"
                        justify="center"
                        className="QuestionDetailsOptions"
                      >
                        <Col span={2}>
                          {d.isAnswer ? (
                            <Button className="green" shape="circle">
                              {optn[i]}
                            </Button>
                          ) : (
                            <Button type="primary" shape="circle">
                              {optn[i]}
                            </Button>
                          )}
                        </Col>
                        {d.optimg ? (
                          <Col span={6} style={{ padding: "5px" }}>
                            <img
                              crossorigin="anonymous"
                              alt="options"
                              width="150"
                              height="150"
                              className="questionDetailsImage"
                              src={d.optimg}
                            />
                          </Col>
                        ) : null}
                        {d.optimg ? (
                          <Col span={14}>{d.optbody}</Col>
                        ) : (
                          <Col span={20}>{d.optbody}</Col>
                        )}
                      </Row>
                    </div>
                  );
                })
              : null}
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="skeletor-wrapper">
        <Skeleton active />
        <Skeleton active />
      </div>
    );
  }
};
